import { render, staticRenderFns } from "./CustomerFunction.vue?vue&type=template&id=5adfb7de"
import script from "./CustomerFunction.vue?vue&type=script&lang=js"
export * from "./CustomerFunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports